import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';

import { SharedModule } from '@app/shared/shared.module';

import { AuthRedirectComponent } from './auth-redirect.component';

@NgModule({
  declarations: [AuthRedirectComponent],
  imports: [RouterModule, SharedModule],
})
export class AuthRedirectModule {}
